import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _WeakMap from "@babel/runtime-corejs3/core-js-stable/weak-map";
export default function createResolver() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (args) {
    return args;
  };
  var lastId = 0;
  var map = new _WeakMap();
  return function () {
    var _context;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _mapInstanceProperty(_context = selector(args)).call(_context, function (arg) {
      if (arg && /^(function|object)$/.test(_typeof(arg))) {
        var argId = map.get(arg);

        if (!argId) {
          argId = ++lastId;
          map.set(arg, argId);
        }

        return "@".concat(argId);
      }

      return _JSON$stringify(arg);
    }).join(',');
  };
}